import { reactive } from 'vue'

export const portalLoaded: Set<string> = reactive(new Set())
export const portalTargets: Map<string, number> = reactive(new Map())
export const portalData: Map<string, Record<string, unknown>> = reactive(
  new Map(),
)

export function addPortal(id: string): void {
  // console.log('+Portal ', id)
  const count = portalTargets.get(id) ?? 0
  portalTargets.set(id, count + 1)
}

export function removePortal(id: string): void {
  // console.log('-Portal ', id)
  const count = portalTargets.get(id) ?? 0
  if (count > 0) {
    portalTargets.set(id, count - 1)
  }
}

export function getPortalName(name: string): string {
  return `portal-target-${name}`
}
